import React from 'react';
import { components } from 'react-select';

const GroupHeading = (props) => (
  <components.GroupHeading className='hs-dropdown-group-heading' {...props} />
);

export default GroupHeading;
